// -----------------------------------------------------------------------------
// Slider on the front page
// -----------------------------------------------------------------------------

// Main slider on the top front page
var mainSlider = function (el) {
  el.slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 6000,
    dots: true,
    accessibility: false,
    arrows: false,
    customPaging: function (slider, i) {
      return $('<span />').text(i);
    },
  });
};